<template>
  <div :class="{'text-input column justify-center': true, 'has-sub-note': !!subNote}">
    <label class="animate" :for="identifier" v-html="label"></label>
    <p class="animate sub-note" v-if="subNote" v-html="subNote"></p>
    <div class="input-container">
      <input
        :id="uniqueId"
        type="text"
        :name="uniqueId"
        :placeholder="computedValue"
        :value="value"
        autofocus
        @input="inputChange($event.target.value)"
        @keydown="checkAndSetCaratPosition($event.target)"
        @keyup.enter="inputAction"
        pattern="\d*"
        :maxlength="maxCharacters"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "TextInput",
  data() {
    return {
      computedValue: null,// the value shown in the input
      inputValue: 0,// used for validation and filtering
      maxCharacters: 15,
      uniqueId: null,
      updater: 0 // used to force vue to update
    }
  },
  props: {
    data: Object,
    action: Function,// function to call on enter press
  },
  computed: {
    currency() {
      return this.$store.state.currency
    },
    label() {
      // label: String,
      return this.data.question
    },
    locale() {
      return this.$store.state.locale
    },
    identifier() {
      // identifier: String,
      return this.data.identifier
    },
    subNote() {
      // subNote: String,
      return this.data.subNote
    },
    // value() {
    //   return this.$store.state.questionValues[this.identifier]
    // },
    value() {
      let value = null

      if(this.inputValue === 0 && this.data.allowZeroValue) {
        value = 0
      } else if(this.inputValue) {
        value = this.computedValue
      }

      return value
    },
    valueType() {
      // valueType: String// can be "number", "dollars", or "days"
      return this.data.valueType
    }
  },
  watch: {
    updater() {
      const iV = this.inputValue
      const inputValue = isNaN(iV) ? 0 : iV
      const locale = this.locale
      let value = ""
      
      // format the value
      switch (this.valueType) {
        case "number":
          value+=inputValue.toLocaleString(locale)
          break
        case "dollars":
          value+=inputValue.toLocaleString(locale, {
            style: "currency",
            currency: this.currency,
            minimumFractionDigits: 0
          })
          break
        case "days":
          value+=`${inputValue.toLocaleString(locale)} Day`
          if(inputValue != 1) value+='s'
          break
        default:
          break
      }

      if(this.computedValue == value) {
        // this forces the value to update and updates the view
        // otherwise, the user could type numbers and then letters
        // and the letters would show in the input
        this.computedValue = null
      }

      this.computedValue = value ? value : 0
    }
  },
  methods: {
    setUniqueValue() {
      this.uniqueId = `${this.identifier}-${Math.floor(Math.random() * 10)}`
    },
    inputChange(event) {
      let newValue = 0
      if(event) {
        if(typeof event === 'number') {
          newValue = event
        } else {
          newValue = this.stripRawNumberFromValue(event)
        }
      }

      this.$store.commit("setQuestionValue", {
        stateKey: this.identifier, 
        incomingValue: newValue
      })

      this.inputValue = newValue
      // force the view to update
      this.updater++
    },
    stripRawNumberFromValue(val) {
      return parseInt(val.replace(/\D/g,''))
    },
    checkAndSetCaratPosition(input) {
      // moves the input carat to the end of the number
      if(input) {
        if(this.valueType === "days") {
          const length = input.value.length

          if(length > 4) {
            const toDecrease = length > 5 ? 5 : 4
            const position = length - toDecrease

            input.focus()
            input.setSelectionRange(position, position)
          }
        }
      }
    },
    setMaxCharacters() {
      // sets the maximum characters allowed for the input
      let maxCharacters;
      switch(this.valueType) {
        case "number":
          maxCharacters = 15
          break
        case "dollars":
          maxCharacters = 16
          break
        case "days":
          maxCharacters = 16
          break
      }

      this.maxCharacters = maxCharacters
    },
    inputAction() {
      if(this.action) {
        this.action()
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setUniqueValue()
      this.setMaxCharacters()
      // set the value if there is one in the store
      this.inputChange(this.$store.state.questionValues[this.identifier])
      // and force the view to update on load
      // this.updater++
    })
  }
}
</script>

<style lang="scss">
  .text-input {
    position: relative;

    label {
      animation-delay: 1.25s;
      animation-name: fadeindown;
      color: $white;
      display: block;
      font-family:"basic-sans";
      font-size: 35px;
      font-weight: bold;
      line-height: 1.21;
      margin: 6px auto 28px auto;
      max-width: 100%;
      text-align: center;

      @media print, screen and (min-width: 48em) {
        font-size: 4.688vw;
      }

      @media print, screen and (min-width: 64em) {
        font-size: 48px;
        max-width: 98%;
      }
    }

    .sub-note {
      margin: 0 auto 28px auto;
      padding: 0;
      text-align: center;
    }

    .input-container {
      margin: 0 auto 43px auto;
      max-width: 100%;
      position: relative;
      width: 228px;

      input[type="text"] {
        appearance: none;
        background: transparent;
        border: 2px solid $white;
        color: $white;
        display: block;
        font-family:"basic-sans";
        font-size: 24px;
        line-height: 58px;
        height: 58px;
        margin: 0;
        width: 100%;
        text-align: center;

        &:focus-visible {
          background-color: $white;
          border-color: $secondary_green;
          color: $secondary_dark_blue;
        }
      }

      ::selection, [contenteditable]::selection {
        background-color: $white;
        color: $secondary_dark_blue;
      }
    }

    &.has-sub-note {
      label {
        margin: 6px auto 0 auto;
      }
    }
  }
</style>